<template>
  <div>
    <div class="mt-4">
      <v-row no-gutters v-if="!loading && dataSet">
        <v-col
          cols="12"
          md="4"
          class="pa-3"
          v-for="(item, n) in dataSet"
          :key="n"
        >
          <v-btn
            width="100%"
            height="100%"
            class="rounded-lg pa-3"
            :to="`/report/${item.period}/${item.scholar_id}`"
          >
            <div class="d-flex flex-column">
              <div
                v-if="item.period == 'baseline'"
                class="d-flex align-center justify-center flex-column"
              >
                <img
                  v-if="gender != 'Female'"
                  src="../../../../assets/img/report/ava-baseline-l.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
                <img
                  v-if="gender == 'Female'"
                  src="../../../../assets/img/report/ava-baseline-p.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
              </div>
              <div
                v-if="item.period == 'midline'"
                class="d-flex align-center justify-center flex-column"
              >
                <img
                  v-if="gender != 'Female'"
                  src="../../../../assets/img/report/ava-midline-l.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
                <img
                  v-if="gender == 'Female'"
                  src="../../../../assets/img/report/ava-midline-p.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
              </div>
              <div
                v-if="item.period == 'endline'"
                class="d-flex align-center justify-center flex-column"
              >
                <img
                  v-if="gender != 'Female'"
                  src="../../../../assets/img/report/ava-endline-l.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
                <img
                  v-if="gender == 'Female'"
                  src="../../../../assets/img/report/ava-endline-p.png"
                  class="obj_fit"
                  width="150px"
                  alt=""
                />
              </div>
              <h4 class="mt-3 text-capitalize text-center">
                {{ item.period }}
              </h4>
            </div>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="loading">
        <v-col cols="12" md="4" class="pa-3">
          <div
            class="rounded-lg pa-3"
            v-if="loading"
            style="width: 100%; height: 100%"
          >
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="pa-3">
          <div
            class="rounded-lg pa-3"
            v-if="loading"
            style="width: 100%; height: 100%"
          >
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="pa-3">
          <div
            class="rounded-lg pa-3"
            v-if="loading"
            style="width: 100%; height: 100%"
          >
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
      <div
        v-if="!loading && dataSet.length == 0"
        class="mt-2 empty d-flex align-center justify-center flex-column"
      >
        <img
          src="../../../../assets/img/redaksi/pagenotfound.png"
          height="150px"
          alt=""
        />
        <b class="default_txt mt-6"
          >No reports have been submitted by admin yet</b
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "profileReportScholar",
  props: ["gender"],
  computed: {
    ...mapState({
      profile: (state) => state.profile,
    }),
  },
  data() {
    return {
      dataSet: null,
      loading: true,
    };
  },
  mounted() {
    let checker = setInterval(() => {
      if (this.profile) {
        this.fetchData();
        clearInterval(checker);
      }
    }, 300);
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `migrations/report_summary?scholar_id=${this.profile.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style></style>
